import { PREFIX_ID } from "@/constants";
import IState from "@/interfaces/IState";

export default (state: IState) => {
  return (id: string) => state.trafficSources[`${PREFIX_ID}${id}`];
};
